// @flow strict

import * as React from 'react';
import Header from '../../components/Header';
import CompanySummary from './Internal/CompanySummary';

type TopPropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  image: string,
|};

type BottomPropTypes = {|
  quote: string,
  author?: string,
  authorTitle?: string,
  authorCompany?: string,
  companyLogo: string,
  companyName: string,
  companyIndustry?: string,
  companyField?: string,
  companyAdvisor?: string,
  pdfLink?: string,
|};

export const CaseStudyTop = (props: TopPropTypes) => {
  return (
    <Header title={props.title} subtitle={props.subtitle} image={props.image}>
      {props.intro}
    </Header>
  );
};

export const CaseStudyBottom = (props: BottomPropTypes) => {
  return (
    <CompanySummary
      logo={props.companyLogo}
      name={props.companyName}
      industry={props.companyIndustry}
      field={props.companyField}
      advisor={props.companyAdvisor}
      pdfLink={props.pdfLink}
      quote={props.quote}
      author={props.author}
      authorTitle={props.authorTitle}
      authorCompany={props.authorCompany}
    />
  );
};
